export default __webpack_public_path__ + "static/media/ppt7_intro.e29f62ce.png";